import { useEffect, useState } from "react";
import { getProductsByCategory } from "../../../api/pagination";

const useCategoryDetails = (initialDetails, all_subCategories) => {
    const [details, setDetails] = useState(initialDetails || null);
    const [subCategories, setSubCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (initialDetails) {
            setDetails(initialDetails);
        }
    }, [initialDetails]);

    useEffect(() => {
        if (!all_subCategories?.length || !details?._id) return;

        const filtered = all_subCategories.filter(
            (sub) => sub?.categoryId === details._id
        );

        setSubCategories(filtered);
    }, [all_subCategories, details?._id]);


    useEffect(() => {
        if (!details?._id) return;

        setLoading(true);

        getProductsByCategory(details._id, (response) => {
            if (response?.status === 200) {
                setProducts(response?.data?.data ?? []);
            }
            setLoading(false);
        });
    }, [details?._id]);

    return {
        details,
        subCategories,
        products,
        loading,
    };
};

export default useCategoryDetails;
